import React from 'react'
import { IoIosSearch } from 'react-icons/io'
import { useAuth } from '../../Context/ContextProvider'
import { useNavigate } from 'react-router-dom'

function Banner({filterData,setFilterData}) {
    const {citiesList,objectToQueryString,categoriesList}=useAuth()
    const navigate = useNavigate()
    const handleSearch = () => {
        let newFilterData = {...filterData}
        if(newFilterData?.keyword?.trim() === ""){
            delete newFilterData?.keyword
        }
        if(newFilterData?.city_code?.trim() === ""){
            delete newFilterData?.city_code
        }
        if(newFilterData?.job_category_id?.trim() === ""){
            delete newFilterData?.job_category_id
        }
        const queryString = objectToQueryString(newFilterData);
        navigate(`/find-new-scholarship?${queryString}`);
    }
    return (
        <div className='banner_joblisting'>
            <div className='w-100 banner-content'>
                <h2 className='text-center'>Find Your Next <br /><span>Opportunity</span></h2>
                <p className='text-center'>Explore thousands of scholarship programs tailored for Bio-Professionals and let <span style={{ color: "#94CB85", fontWeight: "bold" }}>EdFura</span> help you <br/>take the next step in your professional career.</p>
                <div className='banner_inp'>

                    <input onChange={(e)=>setFilterData({...filterData,keyword:e.target.value})} className='inp' placeholder='Search job by Keywords..' />
                    <select onChange={(e)=>setFilterData({...filterData,city_code:e.target.value})} value={filterData?.city_code} className='select_box'>
                        <option hidden>Select Country</option>
                        {citiesList?.map((item)=>{
                            return(
                        <option value={item?.name?.common}>{item?.name?.common}</option>

                            )
                        })}
                       
                    </select>
                    <select onChange={(e)=>setFilterData({...filterData,job_category_id:e.target.value})} value={filterData?.job_category_id} className='select_box'>
                        <option hidden>Select Scholarship Category</option>
                        {categoriesList?.map((item)=>{
                            return(
                                <option value={item?._id}>{item?.name}</option>
                            )
                        })}
                    </select>
        
                    <button
                    onClick={()=>handleSearch()}
                    > Search <IoIosSearch />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Banner